import { loadable } from 'react-lazily/loadable';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { TransactionFunctions, UserFunctions } from '../redux/actions/AppActionFunctions/AppActions';
const GatewayListView = loadable(() => import('../components/Gateway/View/GatewayListView')).default;
const debug = process.env.REACT_APP_DEBUG && false;
const mapStateToProps = (state, ownProps) => {
    debug && console.log('GatewayList own props', ownProps);
    return {
        isAuthenticated: state.AccessReducer.isAuthenticated,
        cognitoUser: state.AccessReducer.cognitoUser,
        userGroupRoles: state.AppReducer.userGroupRoles,
        userCustomers: state.AppReducer.userCustomers,
        userSelectedGroup: state.AppReducer.userSelectedGroup,
        user: state.AppReducer?.user,
        contextCustomer: state.AppReducer.contextCustomer,
    };
};
const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        init: (cognitoUser, userGroupRoles) => {
            debug && console.log('GatewayList Container requested init', ownProps);
        },
        userFunctions: bindActionCreators(UserFunctions, dispatch),
        transactionFunctions: bindActionCreators(TransactionFunctions, dispatch),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(GatewayListView);
